import _ from 'lodash'
import React, { ComponentType } from 'react'
import { ApolloError } from '@apollo/client'
import { ChildDataProps } from '@apollo/client/react/hoc'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Error, Loading } from 'suf_storybook'

const QueryError = (error: ApolloError | object) => {
  const [trace = null] = _.get(error, 'graphQLErrors', [])
  const message = _.get(trace, 'message', 'Server error')
  const code = _.get(trace, 'extensions.code', '')

  return <Error message={message} code={code} />
}

export default (Component: ComponentType<ChildDataProps>) =>
  (props: ChildDataProps) => {
    const { data } = props
    const { loading, error } = data

    if (loading) return <Loading />
    if (error) return <QueryError {...error} />

    return <Component {...props} />
  }
